import React, { useState } from "react";
import { bienLaiThuApi } from "../../../api/bienLaiApi";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import { Button } from "../../buttons";
import { saveAs } from "file-saver-es";

type SendThongBaoPhiPrintBtnProps = {
    disabled: boolean,
    sf_mucphaithu: sf_mucphaithu,
    buttonText?: string
}

const SendThongBaoPhiPrintBtn: React.FC<SendThongBaoPhiPrintBtnProps> = (props) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isExporting, setIsExporting] = useState<boolean>(false);

    const getDataSend = () => {
        return {
            sf_mucphaithu_id: props.sf_mucphaithu.so_chung_tu.includes("CT")
                ? props.sf_mucphaithu.id
                : props.sf_mucphaithu.sf_mucphaithu_parent_id,
            sf_mucphaithu_root_id: props.sf_mucphaithu.id,
        };
    };

    const handlePrint = async () => {
        setIsLoading(true);
        const res = await bienLaiThuApi.print_thongbaophi(getDataSend());

        if (res.is_success && res.data) {
            const printWindow = window.open("", "_blank");

            if (printWindow) {
                printWindow.document.open();
                printWindow.document.write(res.data);
                printWindow.document.close();
                printWindow.focus();
                printWindow.print();
                printWindow.onafterprint = () => {
                    printWindow.close();
                };
            }
        }

        setIsLoading(false);
    };

    const handleExportExcel = async () => {
        setIsExporting(true);
        try {
            const res = await bienLaiThuApi.export_thongbaophi_excel(getDataSend());
            if (res && res.data) {
                const fileName = `ThongBaoPhi_${props.sf_mucphaithu.so_chung_tu || "export"}.xlsx`;
                saveAs(res.data, fileName);
            }
        } catch (error) {
            console.error("Export Excel error:", error);
        }
        setIsExporting(false);
    };

    return (
        <>
            <Button
                type="normal"
                text={props.buttonText || "In thông báo phí"}
                icon="fa fa-print"
                isDisabled={props.disabled}
                isLoading={isLoading}
                onClick={handlePrint}
            />{" "}
            <Button
                type="normal"
                text="Xuất Excel"
                icon="fa fa-file-excel-o"
                isDisabled={props.disabled}
                isLoading={isExporting}
                onClick={handleExportExcel}
            />
        </>
    );
};

export default SendThongBaoPhiPrintBtn;
